import { SystemUpdate } from '../interfaces/system-update';

export const SystemUpdates: SystemUpdate[] = [
  {
    read: true,
    message: 'All Evaluations for Robert D\'Angelo are complete.',
  },
  {
    read: false,
    message: 'An Initial Referral for Tobias Imfeld is ready for review.',
  },
  {
    read: false,
    message: 'A Parent Initial Referral for Sofia Lopez is ready for completion.',
  },
  {
    read: true,
    message: 'Social History Meeting is complete for Amanda Kong.',
  },
  {
    read: false,
    message: 'An Initial Referral for Susanna Hernandez is ready for review.',
  },
]